"use client";
import React, {FC, ReactPortal, useCallback, useContext, useEffect, useState} from "react";
import {SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {createPortal} from "react-dom";
import {DialogContext, DialogContextType} from "@/Master/SDialogFC/SDialogContext";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

/** 用于缓存对话框的“根”和“容器” */
export interface DialogRecord{
    key: string;
    element: React.ReactNode;
    open: boolean;
    DialogView2: FC<any>,
}

/**
 * 全局单例对话框管理器
 * - 负责在 body 中动态创建/销毁容器，并用 createRoot(render) 进行挂载
 */
export class SDialogManagerFC {
    static tag = '[SDialogManagerFC]'
    private static dialogsMap: Record<string, DialogRecord> = {};
    private static callbacks: (maps: Record<string, DialogRecord>) => void;

    static getFCKey<T extends object>(DialogView: FC<T>) {
        return DialogView.displayName || DialogView.name || "AnonymousDialog";
    }

    static initialize(callbacks: (maps: Record<string, DialogRecord>) => void) {
        this.callbacks = callbacks;
    }

    /**
     * 通用打开方法：给定一个函数式组件 (DialogView) 以及 props，
     * 在 document.body 中创建容器，并渲染此组件
     *
     * @param DialogView 你要打开的函数式弹窗组件
     * @param props 组件所需的 props，类型 T 会自动推断
     */
    static openDialog<T extends Partial<SDialogProps>>(
        DialogView: FC<T>,
        props: T = {} as T
    ) {
        // 使用用户传递的 fcKey 或生成默认值
        const key = props.fcKey || this.getFCKey(DialogView);

        // 合并默认参数和用户传递的参数
        const defaultProps: T = {
            fcKey: key,
            isOpen: true,
            ...props, // 用户传递的参数覆盖默认值
        };

        // 要渲染的 JSX
        const element = <DialogView {...defaultProps} key={key} />;

        if (this.dialogsMap[key]) {
            // this.dialogsMap[key].root.render(element);
            return;
        }
        this.dialogsMap[key] = {
            key: key,
            element: element,
            DialogView2: DialogView,
            open: true
        };
        // this.setDialogs(this.dialogsMap);
        if (this.callbacks){
            this.callbacks(this.dialogsMap);
        }

        // this.setDialogs((prev:any) => {});
        // 3. 调用 openDialog
        // return this.addOpenDialog(key, element);
    }

    /**
     * 打开或更新对话框
     * @param key 唯一标识（通常是对话框组件名）
     * @param element 要渲染的 React Node
     */
    // static addOpenDialog(key: string, element: React.ReactNode) {
    //     // 若已存在同名 key，直接“更新”渲染
    //     if (this.dialogsMap[key]) {
    //         // this.dialogsMap[key].root.render(element);
    //         return;
    //     }
    //     this.dialogsMap[key] = {key: key, element: element, open: true};
    //     // this.setDialogs(this.dialogsMap);
    //     if (this.callbacks){
    //         this.callbacks(this.dialogsMap);
    //     }
    //
    // }

    /**
     * 关闭(卸载)对话框
     */
    static closeDialog(key: string) {
        if (this.dialogsMap[key]){
            // const {closeDialog} = useDialogMethods(key);
            // closeDialog?.();
            delete this.dialogsMap[key];
            if (this.callbacks){
                this.callbacks(this.dialogsMap);
            }
        }else{

        }
    }

    static closeDialogFC(fc: React.FC<any>) {
        const keys = this.getFCKey(fc);
        this.closeDialog(keys);
    }


}


const DialogPortalManager: FC = () => {
    const [dialogs, setDialogs] = useState<DialogRecord[]>([]);

    useEffect(() => {
        // Object.values(dialogs).map(({ key, element }) =>
        //     console.log(key, '变动中')
        // )
    }, [dialogs]);

    const openDialog = useCallback((key: string) => {
        setDialogs((prev) => prev.filter((dialog) => dialog.key !== key));
    }, []);

    const closeDialog = useCallback((key: string) => {
        setDialogs((prev) => prev.filter((dialog) => dialog.key !== key));
    }, []);

    const contextValue: DialogContextType = {
        dialogs:dialogs,
        closeDialog,
        openDialog,
    };

    useEffect(() => {
        SDialogManagerFC.initialize((maps:Record<string, DialogRecord>)=>{
            let arr:DialogRecord[] = [];
            Object.values(maps).map((data: DialogRecord) => {
                // console.log(data, '变动中2');
                arr.push(data)
            })
            console.log('变动中3', maps, arr);
            setDialogs(arr);
        });
    }, []);

    return (
        <DialogContext.Provider value={contextValue}>
            {dialogs.map(({key, element, open}) => {
                    if (!open) {
                        return '';
                    }
                    const portal = createPortal(
                        element,
                        document.getElementById('dialogPanel') as HTMLElement,
                        key
                    )
                    return portal;
                }
            )}
        </DialogContext.Provider>
    );
};

export default DialogPortalManager;


// if (Util.isWindow) {
//     // @ts-ignore: 在 TS 中忽略此赋值的类型检查
//     window.SDialogManagerFC = SDialogManagerFC;
// }